import { useRef } from "react";
import { ActionIcon } from "@mantine/core";
import { TimeInput } from "@mantine/dates";
import { IconClock } from "@tabler/icons-react";

export const TimePickerInput = (props) => {

    const ref = useRef(null);

    const pickerControl = (
        <ActionIcon variant="subtle" size={props?.size || 'md'} color="gray" onClick={() => ref.current?.showPicker()}>
            <IconClock stroke={1.5}/>
        </ActionIcon>
    );

    return (
        <TimeInput ref={ref} rightSection={pickerControl} {...props}/>
    );
}